/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Payment methods allowed for disbursing funds.
 */
export const DisbursementPaymentMethodType = {
  PushToCard: "push-to-card",
  RtpCredit: "rtp-credit",
  AchCreditSameDay: "ach-credit-same-day",
  AchCreditStandard: "ach-credit-standard",
} as const;
/**
 * Payment methods allowed for disbursing funds.
 */
export type DisbursementPaymentMethodType = ClosedEnum<
  typeof DisbursementPaymentMethodType
>;

/** @internal */
export const DisbursementPaymentMethodType$inboundSchema: z.ZodNativeEnum<
  typeof DisbursementPaymentMethodType
> = z.nativeEnum(DisbursementPaymentMethodType);
/** @internal */
export const DisbursementPaymentMethodType$outboundSchema: z.ZodNativeEnum<
  typeof DisbursementPaymentMethodType
> = DisbursementPaymentMethodType$inboundSchema;
